import QuestionBase from './../base/question-base.js';

/**
 * @extends {QuestionBase}
 */
export default class TelephoneQuestion extends QuestionBase {
    /**
     * Create instance.
     * @param {object} model - The instance of the model.
     */
    constructor(model){
        super(model);
    }
}
